import { Tooltip } from "antd";
import { ComponentProps, ReactNode } from "react";

type Placement = ComponentProps<typeof Tooltip>["placement"];

interface Props {
  /** Small uppercase heading shown above a divider. */
  header?: ReactNode;
  /** Primary explanatory text. */
  body: ReactNode;
  /** Optional lighter secondary line (e.g. a call to action). */
  hint?: ReactNode;
  placement?: Placement;
  maxWidth?: number;
  /** The element that triggers the tooltip on hover. */
  children: ReactNode;
}

/**
 * Shared light-themed tooltip card used across the pricing tool. Renders an
 * optional uppercase header, a body paragraph and an optional hint line inside
 * a white, rounded, shadowed overlay.
 */
export default function InfoTooltip({ header, body, hint, placement = "top", maxWidth = 250, children }: Props) {
  const title = (
    <div style={{ padding: "2px 2px", maxWidth }}>
      {header && (
        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.05em",
            textTransform: "uppercase",
            color: "rgba(0,0,0,0.4)",
            marginBottom: 8,
            paddingBottom: 6,
            borderBottom: "1px solid rgba(0,0,0,0.06)",
          }}
        >
          {header}
        </div>
      )}
      <div style={{ fontSize: 12.5, lineHeight: 1.5, color: "rgba(0,0,0,0.82)" }}>{body}</div>
      {hint && <div style={{ fontSize: 11.5, lineHeight: 1.45, color: "rgba(0,0,0,0.45)", marginTop: 8 }}>{hint}</div>}
    </div>
  );

  return (
    <Tooltip
      title={title}
      color="#fff"
      placement={placement}
      overlayStyle={{ maxWidth: maxWidth + 26 }}
      overlayInnerStyle={{ padding: 12, borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", maxWidth: maxWidth + 26 }}
    >
      {children}
    </Tooltip>
  );
}
